var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _rect2, _text, _text2, _circle12, _text3, _text4, _line, _line2, _line3, _line4, _line5, _line6, _text5, _text6, _text7, _text8, _path, _path2, _circle13, _circle14, _line7, _rect3, _text9, _g, _line8, _rect4, _text0, _text1, _rect5, _text10, _text11, _path3, _text12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 600",
    width: 440,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#000e20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart-stroke",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#72F238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ef6c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart-area",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(114,242,56,0.22)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(114,242,56,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title-g",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffe896"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket-body",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e0a8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9933dd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flame1",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,80,0,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flame2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffc84c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,80,0,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "multiplier-glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(114,242,56,0.3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(114,242,56,0)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    r: 1.2,
    fill: "white",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 30,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 15,
    r: 1.4,
    fill: "white",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 40,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 20,
    r: 1.2,
    fill: "white",
    opacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 45,
    r: 0.9,
    fill: "white",
    opacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 80,
    r: 0.7,
    fill: "white",
    opacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 85,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 120,
    r: 0.6,
    fill: "white",
    opacity: 0.3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 140,
    r: 1,
    fill: "white",
    opacity: 0.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 60,
    r: 1.2,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 70,
    r: 0.9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;1;0.5",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 55,
    r: 0.8,
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.9;0.2",
    dur: "3.1s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 3,
    fill: "url(#title-g)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 52,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 30,
    fontWeight: 900,
    fill: "url(#title-g)",
    letterSpacing: 6
  }, "CRASH")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 72,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 3
  }, "CASH OUT BEFORE IT CRASHES")), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 140,
    r: 55,
    fill: "url(#multiplier-glow)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 128,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "rgba(255,255,255,0.4)",
    letterSpacing: 2
  }, "MULTIPLIER")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 163,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 44,
    fontWeight: 900,
    fill: "#72F238"
  }, "3.42\xD7")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 205,
    x2: 42,
    y2: 420,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 420,
    x2: 410,
    y2: 420,
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 350,
    x2: 410,
    y2: 350,
    stroke: "rgba(255,255,255,0.04)",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 300,
    x2: 410,
    y2: 300,
    stroke: "rgba(255,255,255,0.04)",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 250,
    x2: 410,
    y2: 250,
    stroke: "rgba(255,255,255,0.04)",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 220,
    x2: 410,
    y2: 220,
    stroke: "rgba(255,255,255,0.04)",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 424,
    textAnchor: "end",
    fontFamily: "monospace",
    fontSize: 10,
    fill: "rgba(255,255,255,0.3)"
  }, "1\xD7")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 354,
    textAnchor: "end",
    fontFamily: "monospace",
    fontSize: 10,
    fill: "rgba(255,255,255,0.3)"
  }, "2\xD7")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 304,
    textAnchor: "end",
    fontFamily: "monospace",
    fontSize: 10,
    fill: "rgba(255,255,255,0.3)"
  }, "3\xD7")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 254,
    textAnchor: "end",
    fontFamily: "monospace",
    fontSize: 10,
    fill: "rgba(255,255,255,0.3)"
  }, "4\xD7")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42,420 C100,418 160,408 200,380 C240,352 280,310 320,268 C345,244 358,230 368,218 L368,420 Z",
    fill: "url(#chart-area)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42,420 C100,418 160,408 200,380 C240,352 280,310 320,268 C345,244 358,230 368,218",
    fill: "none",
    stroke: "url(#chart-stroke)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 285,
    r: 5,
    fill: "none",
    stroke: "#ffc84c",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "5;8;5",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "1;0;1",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 285,
    r: 4,
    fill: "#ffc84c"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 295,
    y1: 280,
    x2: 318,
    y2: 270,
    stroke: "rgba(255,200,76,0.6)",
    strokeWidth: 1,
    strokeDasharray: "3,2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 262,
    width: 54,
    height: 18,
    rx: 4,
    fill: "rgba(255,200,76,0.12)",
    stroke: "rgba(255,200,76,0.4)",
    strokeWidth: 0.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 274,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 9,
    fill: "#ffc84c"
  }, "2.80\xD7")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,218) rotate(-45)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 11,
    ry: 22,
    fill: "url(#rocket-body)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -22,
    rx: 11,
    ry: 10,
    fill: "#c776ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11,-18 Q0,-38 11,-18",
    fill: "#d499ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -4,
    r: 6,
    fill: "#05101e",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -4,
    r: 3.5,
    fill: "rgba(143,255,238,0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11,10 L-20,28 L-5,18 Z",
    fill: "#8b33cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,10 L20,28 L5,18 Z",
    fill: "#8b33cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7,22 Q0,42 7,22",
    fill: "url(#flame1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M-7,22 Q0,42 7,22;M-6,22 Q0,48 6,22;M-7,22 Q0,42 7,22",
    dur: "0.15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-4,24 Q0,36 4,24",
    fill: "url(#flame2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M-4,24 Q0,36 4,24;M-4,24 Q0,40 4,24;M-4,24 Q0,36 4,24",
    dur: "0.12s",
    repeatCount: "indefinite"
  })))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 438,
    x2: 408,
    y2: 438,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 450,
    width: 176,
    height: 50,
    rx: 10,
    fill: "rgba(114,242,56,0.06)",
    stroke: "rgba(114,242,56,0.15)",
    strokeWidth: 1
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 468,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 1
  }, "PLAYING NOW")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 489,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 20,
    fontWeight: 900,
    fill: "#72F238"
  }, "1,284")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 450,
    width: 176,
    height: 50,
    rx: 10,
    fill: "rgba(255,200,76,0.06)",
    stroke: "rgba(255,200,76,0.15)",
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 468,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 10,
    fill: "rgba(255,255,255,0.35)",
    letterSpacing: 1
  }, "MAX WIN")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 489,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 20,
    fontWeight: 900,
    fill: "#ffc84c"
  }, "1000\xD7")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42,420 C100,418 160,408 200,380 C240,352 280,310 320,268 C345,244 358,230 368,218",
    fill: "none",
    stroke: "rgba(199,118,255,0.15)",
    strokeWidth: 8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0;0.2;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 558,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 11,
    fill: "rgba(255,255,255,0.22)",
    letterSpacing: 2
  }, "NEXTGEN ORIGINALS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrash);
export default __webpack_public_path__ + "static/media/crash.35df17016c39529fcad500fa10d5d346.svg";
export { ForwardRef as ReactComponent };